import React from 'react';
import classNames from 'classnames';

import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import { IContract } from '../../../../../../../../../types/contract';

interface Props {
    student: string | number;
}
const CreateContractButton: React.FunctionComponent<Props> = ({ student }: Props) => (
    <div className={classNames('text-right w-100')}>
        <Link to={Router.generate(routes.CONTRACT_CREATE, { id: student })} className={`${'btn btn-success'}`}>
            <span>Create</span>
        </Link>
    </div>
);

export default CreateContractButton;
